import { render, staticRenderFns } from "./TrafegoTabelaAlterada.vue?vue&type=template&id=ebd8e3ec&"
import script from "./TrafegoTabelaAlterada.vue?vue&type=script&lang=js&"
export * from "./TrafegoTabelaAlterada.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./TrafegoTabelaAlterada.vue?vue&type=style&index=1&id=ebd8e3ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports